{
  "version": 1,
  "asset_id": "798ee853-ffe8-4d1f-9c54-8da3f1a03e5f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/798ee853-ffe8-4d1f-9c54-8da3f1a03e5f/sleeve-fitzer-3-440.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/798ee853-ffe8-4d1f-9c54-8da3f1a03e5f/sleeve-fitzer-3-440.jpg",
  "original_filename": "sleeve-fitzer-3-440.jpg",
  "size": 20832,
  "content_type": "image/jpeg",
  "created_at": "2026-09-29T01:15:43Z"
}
